<template>
    <!-- 库存负责人列表 -->
    <vRepertoryPrincipalListComponent :postList="postList" v-if="flag"></vRepertoryPrincipalListComponent>
</template>
<script>
import vRepertoryPrincipalListComponent from '../../listComponent/basicdata/repertoryList/repertoryPrincipalListComponent.vue';
export default {
    name: 'flowSourceLists',
    components: {
        vRepertoryPrincipalListComponent
    },
    data() {
        return {
            postList: {
                headerTitle: true,
                source_file: true,
                batchSaveBtn: true,
                searchBtn: true,
                resetBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>